import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@environment/environment';
import { map, catchError } from 'rxjs/operators';
import { Role } from '@app/models/role';

@Injectable({ providedIn: 'root' })
export class RoleService {
  constructor(private httpClient: HttpClient) { 
  }

  getRoles() {
    return this.httpClient
        .get<any>(`${environment.apiEndPoint}roles/read`)
        .pipe(
          map(res => res ? res.document.records as Role[] : []),
          catchError(this.handleError)
      );
  }

  getRoleById(id) {
    return this.httpClient
        .post<any>(`${environment.apiEndPoint}role/read_one`, JSON.stringify({ id: `${id}` }))
        .pipe(
          map(res => res.document as Role),
          catchError(this.handleError)
      );
  }

  private handleError(error: any): Promise<any> {
    let retour = error?.error?.message || error?.message || error;
    if(error?.error?.data) retour += '<br />'+error?.error?.data;
    return Promise.reject(retour);
  }
}